import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

function SEO({ title, description, keywords, canonicalLink }) {
  return (
    <Helmet
      title={title}
      titleTemplate={!/(Norwegian Block Exchange|NBX)/.test(title) ? 'Norwegian Block Exchange - %s' : '%s'}
      meta={[
        {
          name: 'description',
          content: description
        },
        {
          name: 'keywords',
          content: keywords
        }
      ]}>
      {canonicalLink && <link rel="canonical" href={canonicalLink} />}
    </Helmet>
  );
}

SEO.defaultProps = {
  title: 'Norwegian Block Exchange',
  description:
    'NBX is a secure and transparent cryptocurrency exchange. Buy and sell Bitcoin, Ethereum and other digital assets with NOK. Collect Norwegian Cashpoints every time you trade on NBX. Meet the world of digital assets for the future of wealth.',
  keywords:
    'Norwegian Block Exchange, NBX, cryptocurrencies, btc price, btc, eth, nok, crypto exchange, cryptocurrency trading platform, buy cryptocurrency, kryptobørs, kryptovaluta, kjøp bitcoin, kjøp kryptovaluta',
  canonicalLink: null
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonicalLink: PropTypes.string
};

export default SEO;
